import styles from './progress-bar.module.css';

export type ProgressProps = {
  progress?: number;
  children?: React.ReactNode;
};

/**
 * Renders a progress bar component.
 *
 * @param progress - The current progress value as a percentage (0-100). Defaults to 100.
 * @param children - Optional React nodes to render below the progress bar.
 * @returns A React element displaying the progress bar and any children.
 */
export function Progress({ progress = 100, children }: ProgressProps) {
  return (
    <div className={styles.container}>
      <div className={styles.progress}>
        <div className={styles.bar} style={{ width: `${progress}%` }} />
      </div>
      {children}
    </div>
  );
}
